import { Card, ConfigProvider, Flex, Typography } from "antd";
import ReactMarkdown from 'react-markdown';
import { useSelector } from "react-redux";
import { ReactComponent as Logo } from "../../../assets/Icons/sidebarlogo.svg";
import AnalysisDisplay from "../AnalysisDisplay/AnalysisDisplay";
import "./ResponseMessage.scss";


const { Title } = Typography;

const Responsemsg = ({ msg,loading = false, handleReload }) => {
  const { messages_loading, all_messages } = useSelector(state => state.collecteazeAi);

// let msg = aiDummyResponse;


  const displayMessage = msg?.message;
  function formatMarkdown(md) {
    if (Array.isArray(md)) {
      md = md.join('\n\n');
    }
    if (typeof md !== 'string') return "";
    md = md.replace(/#/g, "");
    md = md.replace(/^(\s*[-*+]\s+.*)$/gm, function (match) {
      return match.startsWith('-') ? match : '- ' + match.replace(/^\s*[-*+]\s*/, '');
    });

    return md;
  }




  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            colorBgContainer: "#ffffff",
            colormessage: "#000000",
            colorBgMask: "#212330",
            colormessagePlaceholder: "#ffffff",
          },
        },
      }}
    >
      <Flex
        className="response_box"
        style={{
          width: "100%",
          maxWidth: '50vw'
        }}
        role="log"
        aria-live="polite"
      >
        <Flex className="company_logo">
          <Logo />
        </Flex>
        <Card
          className="response_suggest"
          // loading={loading}
          style={{
            width: "100%",
            minHeight: "50px",
            messageAlign: "left",
          }}
        >
          <>
            <Title level={3} className="title_levelThree" aria-live="polite">
              {((loading || messages_loading) && msg?.is_dummy) ? (
                <span className="typing-indicator" aria-label="Loading">
                  <span></span><span></span><span></span>
                </span>
              ) : (
                <ReactMarkdown>{formatMarkdown(displayMessage)}</ReactMarkdown>

              )}
              {/* {
                msg.is_dummy && !loading && !messages_loading &&  (
                  <Button style={{ marginLeft: '10px' }} onClick={() => handleReload(msg.session_id, msg?.message_id)}>
                    <ReloadOutlined />
                  </Button>
                )
              } */}
            </Title>

           <AnalysisDisplay plotly_figs ={msg?.plotly_figs} insights={msg?.insights} />
          </>
        </Card>
      </Flex>
    </ConfigProvider>
  );
};

export default Responsemsg;
